import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedRoutingModule } from './shared-routing.module';
import { ChangePasswordComponent } from './_Components/_Common/change-password/change-password.component';
import { ContactComponent } from './_Components/_Common/contact/contact.component';
// import { LoginComponent } from './_Components/_Common/login/login.component';
import { SearchPipe } from 'src/app/_Shared/_Pipes/search.pipe';
import { FilterMeetingHostPipe } from 'src/app/_Shared/_Pipes/meetingHost.pipe';
import { AddLimiterPipe } from 'src/app/_Shared/_Pipes/add-limiter.pipe';
import { DropdownTextLimiterPipe } from 'src/app/_Shared/_Pipes/dropdown-text-limiter.pipe';
import { FilterPipe } from 'src/app/_Shared/_Pipes/filter.pipe';
import { EmptyStateComponent } from 'src/app/_Shared/_Components/_Generic/error-pages/empty-state/empty-state.component';
// import { ForbiddenComponent } from 'src/app/_Shared/_Components/_Generic/error-pages/forbidden/forbidden.component';
// import { NotFoundComponent } from 'src/app/_Shared/_Components/_Generic/error-pages/not-found/not-found.component';
import { FooterComponent } from 'src/app/_Shared/_Components/_Generic/footer/footer.component';
import { HeaderComponent } from 'src/app/_Shared/_Components/_Generic/header/header.component';
import { LoaderComponent } from 'src/app/_Shared/_Components/_Generic/loader/loader.component';
// import { NotificationsComponent } from 'src/app/_Shared/_Components/_Generic/notifications/notifications.component';
import { PasswordStrengthBarComponent } from 'src/app/_Shared/_Components/_Generic/password-strength-bar/password-strength-bar.component';
import { SideNavComponent } from 'src/app/_Shared/_Components/_Generic/side-nav/side-nav.component';
import { SlotComponent } from 'src/app/_Shared/_Components/_Generic/slot/slot.component';
import { SlotDetailComponent } from 'src/app/_Shared/_Components/_Generic/slot-detail/slot-detail.component';
import { TabsComponent } from 'src/app/_Shared/_Components/_Generic/tabs/tabs.component';
import { EmailRestricterDirective } from 'src/app/_Shared/_Directives/email-restricter.directive'
import { CustomDatePipe } from 'src/app/_Shared/_Pipes/custom-date.pipe';
import { PopupModalComponent } from './_Components/_Generic/popup-modal/popup-modal.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularSvgIconModule } from 'angular-svg-icon';
// import { ToastMessage } from 'src/app/_Shared/_Components/_Generic/toast/toast.component';

const components = [ChangePasswordComponent,ContactComponent,FooterComponent,HeaderComponent,
  LoaderComponent,PasswordStrengthBarComponent,SideNavComponent,SlotComponent,SlotDetailComponent,TabsComponent,EmailRestricterDirective,EmptyStateComponent
]
const pipes = [SearchPipe,FilterMeetingHostPipe,AddLimiterPipe,DropdownTextLimiterPipe,FilterPipe,CustomDatePipe]

@NgModule({
  declarations: [...components, ...pipes, PopupModalComponent],
  imports: [
    CommonModule,
    SharedRoutingModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    AngularSvgIconModule.forRoot()
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  exports: [...components, ...pipes]
})
export class SharedModuleNew { }
